import React, { useEffect } from "react";
import "../Style/AboutUs.css";
import a1 from "../Assets/About/a1.png";
import a2 from "../Assets/About/a2.png";
import a3 from "../Assets/About/a3.png";
import a4 from "../Assets/About/a4.png";
import a5 from "../Assets/About/a5.png";
import a6 from "../Assets/About/a6.png";
import a7 from "../Assets/About/a7.png";
import { useAppointment } from "./AppointmentContext.js";
import BookAppointment from "./BookAppointment.js";

const AboutUs = () => {
  const { appointmentData, handleAppointment } = useAppointment();
  const isMobile = window.innerWidth <= 768;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const aboutContent = [
    {
      imageUrl: a3,
      name: "Personalized Care:",
      desc: "We understand that every person is different. Our homeopaths create a treatment plan specifically tailored to your individual symptoms, history, and needs. We take the time to listen and ensure that you feel comfortable throughout your journey to healing.",
    },
    {
      imageUrl: a4,
      name: "Holistic Healing:",
      desc: "We don’t just treat symptoms—we focus on the person as a whole. Our remedies address physical, emotional, and mental health, aiming to achieve long-term wellness that extends far beyond temporary relief.",
    },
    {
      imageUrl: a5,
      name: "Natural Remedies:",
      desc: "Homeopathy is a natural and non-invasive treatment option that stimulates your body’s ability to heal itself. Our remedies are made from plant, mineral, and animal substances and are gentle yet effective, with no harmful side effects.",
    },
    {
      imageUrl: a6,
      name: "Long-Term Wellness:",
      desc: "Unlike conventional medicine, which often focuses on masking symptoms, our goal is to achieve lasting health by addressing the underlying causes of illness. We aim to help you feel better, not just in the short term, but for the long haul.",
    },
  ];
  return (
    <div className="aboutus-container">
      <div className="about-sec-1">
        <h1 className="about-sec-h1">About Us</h1>
        <p className="about-sec-p">
          Welcome to <b>Homeopathy Healthcare and Research Center</b> , where
          your health is our priority. We are a team of dedicated healthcare
          professionals offering both online and offline doctor consultation
          services, ensuring that you receive expert care whenever and wherever
          you need it.
        </p>
        <p className="about-sec-p">
          Our mission is to provide comprehensive medical care in a way that
          fits your lifestyle. Whether you prefer the convenience of consulting
          a doctor from the comfort of your home through our secure online
          platform or prefer an in-person consultation at our clinic, we are
          here to serve you.
        </p>
      </div>

      <div className="about-sec-2">
        <h1 className="about-sec-2-h1">
          Meet Our Homeopathic Doctor –{" "}
          <b style={{ color: "var(--primary-color)" }}>Dr. R.K. VISHWAKARMA</b>{" "}
        </h1>
        <p className="about-sec-p" style={{ marginTop: "20px" }}>
          At <b>HOMOEOPATHIC HEALTH CARE & RESEARCH CENTER</b>, we are proud to
          have an experienced and dedicated homeopathic doctor at the heart of
          our practice. Our doctor’s mission is to help you achieve holistic
          well-being by offering natural, safe, and effective remedies tailored
          to your unique health needs.
        </p>
      </div>

      <div className="about-sec-3">
        <div className="about-sec-3-1">
          <img src={a1} />
          <div
            className="sign-1"
            style={{ fontSize: "20px", paddingTop: "-10px" }}
          >
            Dr. R.K. VISHWAKARMA
            <br />
            <span style={{ fontSize: "16px", margin: "5px" }}>
              B.H.M.S , M.D.
            </span>
          </div>
        </div>
        <div className="about-sec-3-2">
          <p className="about-sec-3-p">
            About{" "}
            <b style={{ color: "var(--primary-color)",fontSize:"20px",fontWeight:"600" }} >
              Dr. R.K. VISHWAKARMA
            </b>
          </p>
        
          <h2
            style={{
              fontSize: isMobile ? "23px" : "",
              margin: isMobile ? "10px 0px 0px 0px" : "",
            }}
          >
            Education & Qualifications
          </h2>
          <b className="about-sec-3-p1" style={{fontSize:"20px",fontWeight:"600"}}>
            B.H.M.S , M.D. , Consultant Physician
          </b>
          <p className="about-sec-3-p">
            <b style={{ color: "var(--primary-color)",fontSize:"20px",fontWeight:"600" }}>
              Dr. R.K. VISHWAKARMA
            </b>{" "}
            currently serves as the <b style={{color: "var(--primary-color)",fontSize:"20px",fontWeight:"600"}}>Secretary of the Homeopathic Medical
            Association of India, Jaunpur Unit.</b> He remains actively engaged in
            advancing his knowledge of the latest developments in homeopathy to
            ensure the highest standard of care for his patients.
          </p>
          {/* <p className="about-sec-3-p2">
            <b style={{ color: "var(--primary-color)" }}>
              Dr. R.K. VISHWAKARMA
            </b>{" "}
            is also an active member of{" "}
            <b>HOMEOPATHY MEDICAL ASSOCIATION OF INDIA</b> , and is committed to
            staying updated on the latest advancements in homeopathy to provide
            the best possible care to patients.
          </p> */}
        </div>
      </div>

      <div className="about-sec-4">
        <div className="about-sec-4-1">
          <h1 className="about-sec-2-h1" style={{ width: "95%" }}>
            Schedule a Consultation with{" "}
            <b style={{ color: "var(--primary-color)",fontWeight:"600" }}>
              Dr. R.K. VISHWAKARMA
            </b>
          </h1>
          <p className="about-sec-4-p1">
            If you’re ready to experience the healing power of homeopathy, we
            invite you to schedule a consultation with{" "}
            <b style={{ color: "var(--primary-color)",fontSize:"20px",fontWeight:"600" }}>
              Dr. R.K. VISHWAKARMA
            </b>
            . During your appointment,{" "}
            <b style={{ color: "var(--primary-color)",fontSize:"20px",fontWeight:"600" }}>
              Dr. R.K. VISHWAKARMA
            </b>{" "}
            will take the time to understand your health history and concerns,
            and together, you’ll create a personalized treatment plan designed
            to restore balance and promote optimal health.
          </p>
          <button
            className="treat-btn"
            style={{ marginTop: "10px" }}
            onClick={handleAppointment}
          >
            BOOK APPOINTMENT
          </button>
          <p className="about-sec-4-p1">
            We look forward to partnering with you on your path to wellness!
          </p>
        </div>
        <div className="about-sec-4-imag">
          <img src={a2} />
        </div>
      </div>

      <div className="about-sec-5">
        <h1
          className="about-sec-2-h1"
          style={{
            textAlign: "center",
            marginTop: "50px",
            marginBottom: "20px",
          }}
        >
          What Sets Us Apart
        </h1>
        {aboutContent.map((content) => (
          <div className="about-sec-5-content">
            <div className="about-sec-5-img">
              <img src={content.imageUrl} />
            </div>
            <div className="about-sec-5-text">
              <h1 className="about-sec-5-h1">{content.name}</h1>
              <p className="about-sec-5-p1">{content.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="about-sec-6">
        <div className="about-sec-6-1">
          <h1 className="about-sec-2-h1">Our Commitment to You :</h1>
          <p className="about-sec-4-p1">
            At [Your Homeopathy Practice Name], we are committed to providing
            the highest standard of care with a personal touch. We pride
            ourselves on creating an environment where you feel understood,
            supported, and cared for every step of the way. Whether you are new
            to homeopathy or have been using it for years, we are here to help
            you achieve the health and vitality you deserve.
          </p>
          <p className="about-sec-4-p1">
            We look forward to walking with you on your journey to better health
            and well-being!
          </p>
        </div>
        <div className="about-sec-6-img">
          <img src={a7} />
        </div>
      </div>

      <div className="about-sec-last">
        <p>
          Homeopathic medicines are prepared from tiny amounts of proven healing
          substances derived mainly from plants, minerals and animals. They are
          given in very minute doses so that they are non-toxic, and are very
          safe. Unlike antibiotics and other medicines, homeopathic medicines
          will not hamper digestion; will not lower immune resistance; will not
          produce allergic reactions and are safe in the long term if taken as
          directed by a qualified homeopath.
        </p>
      </div>
      {appointmentData && (
        <div className="popup-overlay" onClick={handleAppointment}>
          <BookAppointment handleAppointment={handleAppointment} />
        </div>
      )}
    </div>
  );
};

export default AboutUs;
